import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'barequest_invoice';
export const route = 'barequest_invoice/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "request-invoice" */
/* webpackPrefetch: true */
'../components/RequestInvoicePage')));